import { render, staticRenderFns } from "./flipper.global.vue?vue&type=template&id=1e174036&"
import script from "./flipper.global.vue?vue&type=script&lang=js&"
export * from "./flipper.global.vue?vue&type=script&lang=js&"
import style0 from "./flipper.global.vue?vue&type=style&index=0&id=1e174036&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports